<template lang="pug">
include /mixins
+b.tt-card-product-inner.relative
  +b.tt-remove-from-cart.--top-right.SPAN.mdi.mdi-close(
    v-if="!isCartModal"
    @click='$emit("removeFromCart")'
  )
  +b.g-row--align_center.--justify_end-xl
    +b.g-cell.g-cols--3.--2-xl.relative
      +b.tt-picture--size_auto.--size_auto-h.cart-product-img--mini-variant.PICTURE.relative
        source(
          type="image/webp"
          :srcset="complectInfo && complectInfo.complect_img.preview_webp"
        )
        +e.body.IMG(
          v-if='complectInfo && complectInfo.complect_img && complectInfo.complect_img.preview'
          :src='complectInfo.complect_img.preview',
        )
        +e.body.IMG(
          v-else
          src='https://via.placeholder.com/60x60',
        )
      //- +b.cart-label-wrap
        +b.cart-label--static.is_sale(
        )
          +e.title.P {{ _('акция') }}
    +b.g-cell.g-cols--9.--10-xl
      +b.tt-space_ml--2
        +b.ds-caption--size_2md.--size_3md-xl.--bold.A.tt-link--variant_start.tt-space_mb--3(
          v-if='complectInfo && complectInfo.url'
          :href='complectInfo.url'
        ) {{ campaignInfo.campaign_title }}
        row(
          justify='start'
          align='center'
          space='sm'
        )
          cell(
            cols='narrow'
          )
            svg(width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M0.5 2.42188V8.82187L5.5 10.4219M0.5 2.42188L5.5 4.02187M0.5 2.42188L3 1.42188M5.5 4.02187V10.4219M5.5 4.02187L7.89809 3.25449M5.5 10.4219L10.5 8.82187V2.42188M10.5 2.42188L8 1.42188L5.87139 0.570431C5.63298 0.475067 5.36702 0.475067 5.12861 0.570431L3 1.42188M10.5 2.42188L7.89809 3.25449M3 1.42188L7.89809 3.25449" stroke="black" stroke-linejoin="round")
          cell(
            cols='narrow'
          )
            +b.ds-caption--size_xs.--medium.--color_text-10.P {{ _('Комплект') }}{{ isCartModal ? "" : ":" }}
          template(v-if="!isCartModal")
            cell(
              cols='narrow'
            )
              +b.ds-caption--size_xs.--medium.--color_text-10.P {{ setLength }}  {{ $tc('товар', setLength ) }}
            cell(
              cols='narrow'
            )
              //- modal-trigger(
              //-   name='SetView',
              //-   :set='set',
              //-   :campaign="campaignInfo"
              //-   url='Cart/SetView',
              //-   :classes='["cart-modal"]'
              //- )
              //-   template(#default='{ open }')
              //-     +b.tt-link--styling_default.ds-caption--size_xs.--medium.SPAN(
              //-       @click.prevent='open'
              //-     ) {{ _('Дивитись') }}
              modal-trigger(
                name='SetView',
                :set='set',
                :id='id',
                :gifts='gifts',
                :campaign="campaignInfo"
                url='Cart/SetViewDetailed',
                :classes='["package-modal"]'
              )
                template(#default='{ open }')
                  +b.tt-link--styling_default.--text-10.ds-caption--size_xs.SPAN(
                    @click.prevent='open'
                  ) {{ _('Дивитись') }}
        +b.tt-space_mt--4.tt-space_mb--6
          //- +b.tt-article.tt-cart-product-article.--offset_none.is-visible-xl
          //-   +b.ds-caption--size_xs.SPAN {{ _('Артикул:') }} {{ campaignInfo.campaign_id }}
    //- +b.g-cell.g-cols--9.--10-xl
      +b.tt-article.tt-cart-product-article.is-disable-xl.tt-space_ml--2
        +b.ds-caption--size_xs.SPAN {{ _('Артикул:') }} {{ campaignInfo.campaign_id }}
      //- +b.g-row--appearance_column.--justify_between.full-h
      //-   +b.g-cell.g-cols--12
      //-     +b.g-row.--justify_between.full-h
      //-       +b.g-cell.g-cols--12.--6-xl
      //-       //- +b.g-cell.g-cols--6.--3-xl
      //-       //-   +b.ds-caption--size_2xs.--light.--appearance_right.P {{ _('Артикул:') }} #[+b.ds-caption--medium.SPAN {{ _('Акция') }} ]
      //-       +b.g-cell.g-cols--6.--3-xl
      //-   +b.g-cell.g-cols--12
      //-   +b.g-cell.g-cols--12
    //- +b.g-cell.g-cols--12
  +b.tt-space_ml--2
    +b.g-row--align_center(
      :class="{ 'g-row--justify_end': isCartModal }"
    )
      +b.g-cell.g-cols--3.--2-xl.relative
      +b.g-cell.g-cols--7
        .is-visible-xl
          row(align='center' :appearance='["column-reverse-till-m2d", "nowrap", "spaced"]' :class="{ 'g-row--justify_end': isCartModal }")
            cell(v-if='isCartModal')
              +b.ds-caption--size_sm.--medium.--appearance_right.P {{ campaignInfo.complect_count }} {{ _('шт.') }}
            cell(v-else)
              +b.COUNTER.tt-counter--variant_1(
                :amount='campaignInfo.complect_count',
                @change='$emit("updateCart", { info: $event, campaign: campaignInfo, set })'
                :max-count='maxCount'
                :show-error='maxCount < campaignInfo.complect_count'
              )
          +b.ds-caption--size_2xs.--regular.--color_red(
            v-if='maxCount < campaignInfo.complect_count'
          ) {{ _('Товара нет в необходимом Вам количестве, доступно ') }} {{ maxCount }}
      +b.g-cell.g-cols(
        :class="isCartModal ? 'g-cols--narrow' : 'g-cols--12 g-cols--3-xl'"
      )
        +b.tt-space_mt--2.--0-xl
        row(
          justify='end'
          align='center'
        )
          cell.is-disable-xl(
            cols='auto'
          )
            row(align='center' :appearance='["column-reverse-till-m2d", "nowrap", "spaced"]')
              cell(v-if='isCartModal')
                +b.ds-caption--size_sm.--medium.--appearance_right.P {{ campaignInfo.complect_count }} {{ _('шт.') }}
              cell(v-else)
                +b.tt-counter.--variant_1.COUNTER(
                  :amount='campaignInfo.complect_count',
                  @change='$emit("updateCart", { info: $event, campaign: campaignInfo, set })'
                  :max-count='maxCount'
                  :show-error='maxCount < campaignInfo.complect_count'
                )
            +b.ds-caption--size_2xs.--regular.--color_red(
              v-if='maxCount < campaignInfo.complect_count'
            ) {{ _('Товара нет в необходимом Вам количестве, доступно ') }} {{ maxCount }}
          cell(
            cols='narrow'
            v-if="!isCartModal"
          )
            row(align='end' justify='end' appearance='column')
              template(v-if='campaignInfo.price_with_discount')
                //- cell(cols)
                //-   +b.ds-caption--size_sm.--semibold.--grey.--appearance_right.--appearance_nowrap.--appearance_line-througt.--color_semigrey.SPAN(
                //-     v-html='getSplittedHtml(campaignInfo.price_without_campaign)'
                //-   )
                cell(
                  cols='narrow'
                  v-if='campaignInfo.complect_discount_percent'
                )
                  +b.tt-cart-discount-block
                    +b.tt-space_mr--2
                      +b.ds-caption--size_xs.--medium.--color_text-8.--appearance_right.--appearance_nowrap.--appearance_line-througt.--line-h_xs.SPAN(
                        v-html='getSplittedHtml(campaignInfo.price_without_campaign)'
                      )
                    +b.tt-cart-discount-percent
                      +b.ds-caption--size_3xs.--bold.--color_white.--line-h_xs.P(
                        v-if='campaignInfo.complect_discount_percent'
                      ) -{{ campaignInfo.complect_discount_percent }}%
                cell(cols )
                  +b.ds-caption--size_2md.--semibold.--appearance_right.--appearance_nowrap.--color_red.SPAN.tt-space_ml--1(
                    v-html='getSplittedHtml(campaignInfo.price_with_discount)'
                  )
                cell(cols="12" )
                  +b.ds-caption--size_xs.--medium.--appearance_right.--appearance_nowrap.--color_text-8.P
                    ui-currency-converter.ds-caption--appearance_right(
                      :price='campaignInfo.price_with_discount'
                      :site-currency="current_site_currency"
                      :national-currency="national_currency"
                      :national-currency-symbol="national_currency_symbol"
                    )
              cell(cols="11-till-sm" v-else)
                +b.ds-caption--size_2md.--semibold.--appearance_right.--color_text-10.P(
                  v-html='getSplittedHtml(campaignInfo.price_without_campaign)'
                )
                ui-currency-converter.ds-caption--appearance_right(
                  :price='campaignInfo.price_without_campaign'
                  :site-currency="current_site_currency"
                  :national-currency="national_currency"
                  :national-currency-symbol="national_currency_symbol"
                )

</template>

<script>
import { mapState } from 'vuex'

const SET_PREVIEWS_COUNT = 8

export default {
  name: 'CartSetPreview',
  props: {
    set: {},
    id: String,
    classes: String,
    gifts: Array,
    isCartModal: {
      default: () => false,
    },
    complect: {
      default: () => {}
    }
  },
  data() {
    return {
      current_site_currency: window.current_site_currency,
      national_currency: window.national_currency,
      national_currency_symbol: window.national_currency_symbol,
      currency: window.currency,
    }
  },
  computed: {
    ...mapState('cart', [
      'cart',
    ]),
    campaignInfo() {
      const [, id, number] = this.id.split('_')
      return this.complect ? this.complect :  this.cart.parameters.complects_info
        .find(i => i.campaign_id === Number(id) && i.number_complect === Number(number))
    },
    maxCount() {
      return Math.min(...this.set.map(i => Math.floor(i.base.element.props.stock / i.base.parameters.complect_coefficient)))
    },
    setPreviews() {
      const s = JSON.parse(JSON.stringify(this.set.filter(e => e.base.element.props.product)))
      return s.splice(0, SET_PREVIEWS_COUNT)
    },
    firstSet() {
      return this.set[0]
    },
    complectInfo() {
      return this.firstSet.relations[0]?.element?.props?.campaign?.props || this.cart.gifts[this.id][0]?.base?.element?.props?.campaign?.props
    },
    setLength() {
      console.log("🚀 ~ this.set:", this.set)
      return this.set.reduce((acc, obj) => acc + obj.base.quantity, 0)
    },
  },
}
</script>
